import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import router from '@/router/index'

// Notification

export default function useItemsMasterList() {
  // Use toast
  const toast = useToast()
  const route = router.history.current

  const refItemsMasterTable = ref(null)

  // Table Handlers
  const tableColumns = [
    {
      key: 'itemNo',
      label: 'item no',
      sortable: true,
    },
    {
      key: 'description',
      label: 'Item Name',
      sortable: true,
    },
    {
      key: 'unit',
      label: 'unit',
      sortable: true,
    },
    {
      key: 'supplier',
      label: 'Supplier/Vendor',
      sortable: true,
    },
  ]
  const perPage = ref(route.query.perPage ?? process.env.VUE_APP_PER_PAGE_CONTENT)
  const totalItemsMaster = ref(0)
  const searchQuery = ref(route.query.search || '')
  const currentPage = ref(route.query.page ?? 1)
  const perPageOptions = [10, 25, 50, 100]
  const sortBy = ref(route.query.sortBy ?? 'itemNo')
  const isSortDirDesc = ref(route.query.sortDesc === 'true')
  const toDeletedID = ref(null)
  const itemsMasterData = ref([])
  let initialLoad = true
  const currentDataLength = ref(0)
  const vendorFilter = ref(route.params.id || null)

  const dataMeta = computed(() => {
    const localItemsCount = refItemsMasterTable.value ? refItemsMasterTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalItemsMaster.value,
    }
  })

  const refetchData = () => {
    refItemsMasterTable.value.refresh()
  }

  watch([searchQuery, currentPage], () => {
    refetchData()
  })

  const fetchItemsMaster = (ctx, callback) => {
    store
      .dispatch('app-items-master/fetchItemsMaster', {
        search: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        vendorFilter: vendorFilter.value,
      },
      { root: true })
      .then(response => {
        const { itemsMasters, total } = response.data
        itemsMasterData.value = itemsMasters
        currentDataLength.value = itemsMasters.length
        callback(itemsMasters)
        totalItemsMaster.value = total
        if (!initialLoad) {
          router.replace({
            query: {
              search: searchQuery.value,
              perPage: perPage.value,
              page: currentPage.value,
              sortBy: sortBy.value,
              sortDesc: isSortDirDesc.value,
              vendorFilter: vendorFilter.value,
            },
          }).catch(() => {})
        }
        initialLoad = false
      })
      .catch(error => {
        toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const deleteItemsMaster = () => {
    store
      .dispatch('app-items-master/deleteItemsMaster', {
        id: toDeletedID.value,
      },
      { root: true })
      .then(response => {
        refetchData()
        toast({
          component: ToastificationContent,
          props: {
            title: response.data.message ?? '',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
      .catch(error => {
        console.log(error)
        toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveItemsMasterstatusVariant = status => {
    if (status === 'published') return 'success'
    if (status === 'pending') return 'warning'
    if (status === 'hidden') return 'secondary'
    return 'primary'
  }

  return {
    fetchItemsMaster,
    tableColumns,
    perPage,
    currentPage,
    itemsMasterData,
    totalItemsMaster,
    dataMeta,
    perPageOptions,
    sortBy,
    isSortDirDesc,
    refItemsMasterTable,

    searchQuery,

    resolveItemsMasterstatusVariant,
    refetchData,
    currentDataLength,

    toDeletedID,
    deleteItemsMaster,
  }
}
